// extracted by mini-css-extract-plugin
module.exports = {"ComponentInvalid":"styles_ComponentInvalid__2Bj9-","FormInvalid":"styles_FormInvalid__1Qs7-","FormControl":"styles_FormControl__3KA0y","width50":"styles_width50__11OeR"};